export default __webpack_public_path__ + "static/media/app.4b813f0a.svg";